import React from "react";
import Logo from "../../assets/Opensource-01.png";
import "./printingHeader.css";

const PrintingHeader = ({
  title = "عنوان التقرير",
  count = 0,
  selectedRegion,
  showCount = true, // Default to showing count
  showRegion = false,
  technicianName, // ✅ new prop
}) => {
  return (
    <div className="print-only">
      <div className="header-printing">
        <div className="header-right">
          <h2>مؤسسة محمد صالح اليحيي للصناعة والتجارة</h2>
          <p>تكييف صحراوي واسبيلت _غطاسات منزلية قطع غيار -أجهزة كهربائية</p>
        </div>
        <div className="header-middle">
          <img src={Logo} alt="Logo" />
        </div>
      </div>
      <div className="headline">
        <h2>
          {title}
          {showCount && count > 0 && ` (${count})`}
          {technicianName && ` ${technicianName}`}
          {showRegion &&
            selectedRegion &&
            selectedRegion !== "all" &&
            ` | ${selectedRegion}`}
        </h2>
      </div>
    </div>
  );
};

export default PrintingHeader;
